module.exports = __webpack_public_path__ + "static/media/Jonathan.7014edf1.jpg";